// `cn` — clsx puis tailwind-merge : la dernière classe Tailwind gagne (`cn("p-2", cond && "p-4")`).
// La même fonction que celle du TailAdmin vendoré au cockpit, sans dépendre de lui.
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
